import { UploadFile } from 'antd/lib/upload/interface';
import { FormQuestion, FormTemplate } from 'api/form/types';
import { AssigneeValue } from 'api/tasks';

export type FormInstance = {
  formTemplate: FormTemplate;
  formInstanceId: number;
  createdAt: number;
  templateId: number;
  accountId: number;
  shareUrl: string;
};

export type FormInstanceByProject = Pick<
  FormInstance,
  'formInstanceId' | 'templateId'
> & {
  taskName: string;
};

export type FormInstancesByProject = {
  projectId: number;
  instances: FormInstanceByProject[];
};

export enum FormAnswerTypes {
  Text = 'TEXT',
  Number = 'NUMBER',
  Decimal = 'DECIMAL',
  Choices = 'CHOICES',
  Attachment = 'ATTACHMENT',
  MatrixRadio = 'MATRIX',
  MatrixCheckbox = 'MATRIX',
}
export type FormAnswerValues =
  | string
  | number
  | number[]
  | {
      attachmentId: number;
    }[];

export type FormAnswerMeta = {
  questionId: number;
  type: FormAnswerTypes;
  answers: FormAnswerValues;
};

export type FormAnswerMetaJson = {
  [key: string]: FormAnswerMeta;
};
export type FormAnswer = {
  answerId: number;
  accountId: number;
  answerMetaJson: FormAnswerMetaJson;
  createdAt: number;
  formInstanceId: number;
  createdBy: number;
  updatedAt: number;
  updatedBy: number;
};

export type FormInstanceAnswers = {
  instanceId: number;
  taskId: number;
  projectId: number;
  dueDate?: number;
  completedAt?: number;
  assignee?: AssigneeValue;
  answers: FormAnswer[];
  taskName?: string;
};

export interface FormAnswerImage {
  name: string;
  sizeInBytes: number;
  location: string;
  attachmentId: number;
  publicVisibility: boolean;
  relativePath: string;
  thumbLocation: string;
  createdBy: number;
  createdAt: number;
}

export interface UploadFormAnswerImage extends UploadFile {
  attachment?: FormAnswerImage;
}

export interface WebFormTaskDetails {
  projectId: number;
  taskId: number;
  companyLogoUrl: string;
  companyName: string;
  customerCompanyLogoUrl: string;
  customerCompanyName: string;
  projectName: string;
}
export interface WebFormAnswer extends FormAnswer {
  lastActedUser?: string;
}
export enum FormTypes {
  WebForm = 'WEB_FORM',
  FormPane = 'FORM_PANE',
  Invalid = 'INVALID',
}
export interface WebFormData {
  formType: FormTypes;
  formInstance?: FormInstance;
  taskDetails: WebFormTaskDetails;
  formAnswer?: WebFormAnswer;
}

export type FormTemplateInstanceAnswer = {
  formInstanceId: number;
  projectId: number;
  projectName: string;
  taskName: string;
  companyId: number;
  companyLogoUrl: string;
  companyName: string;
  companyUrl: string;
  answerId?: number;
  createdAt: number;
  createdBy: number;
  updatedAt: number;
  updatedBy: number;
  taskId: number;
  dueDate?: number;
  completedAt?: number;
  assignee?: AssigneeValue;
  answerMetaJson: FormAnswerMetaJson;
};

interface FormTemplateQuestions extends FormQuestion {
  isDeleted: boolean;
}
export interface FormTemplateAnswers {
  questionsList: FormTemplateQuestions[];
  answers: FormTemplateInstanceAnswer[];
}
